exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fm-modal-properties .modal-body .row {\n  margin-bottom: 0.3rem;\n  padding-top: 0.3rem;\n  padding-bottom: 0.3rem;\n}\n.fm-modal-properties .modal-body .row .fa-copy {\n  padding-top: 0.2rem;\n  display: none;\n  cursor: pointer;\n}\n.fm-modal-properties .modal-body .row:hover {\n  background-color: #f8f9fa;\n}\n.fm-modal-properties .modal-body .row:hover .fa-copy {\n  display: block;\n}\n.fm-modal-properties .modal-body .col-2 {\n  font-weight: bold;\n}\n.fm-modal-properties .modal-body .col-9 {\n  word-wrap: break-word;\n}", ""]);

// exports
